import useSocketService, { EmitStores } from "@/hooks/useSocketService";
import type { EventGrandPrizeState } from "@/types";

export async function saveGrandPrizeState(params: {
	eventGrandPrizeState: EventGrandPrizeState;
}): Promise<boolean> {
	const socketService = useSocketService();

	try {
		await socketService.emitSaveRequest({
			stores: [EmitStores.RESOURCES, EmitStores.BUILDINGS_STORAGE],
			eventGrandPrizeState: params.eventGrandPrizeState,
		});
		return true;
	} catch (error: unknown) {
		console.error("[saveGrandPrizeState]", error);
		return false;
	}
}
